<template>
    <div>
      <div class="col-md-12">
        <boton-atras :nombre_ruta="'Finanzas-publicas'"/>
      </div>
      <div class="container text-center mb-4">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Evolución del Gasto</h1>
      </div>
      <div>
        <h4>Gastos</h4>
        <!-- <pre>{{ gastosHistorico.seccion }}</pre> -->
        <tabla-simple v-if="gastosHistorico.seccion" id="tablaEGH" class="mt-2" titulo="Historico" :datos="gastosHistorico" />
      </div>

      <div class="contenedor_evol_gasto">
        <h4>Evolución del Gasto (Clasificación y Desagregación de Egresos)</h4>
        <div class="mb-4" v-if="yearOptions">
          <label class="labelTextarea">Seleccione año a consultar</label>
          <px-select idSelect="evol-gasto" placeholder="Seleccione" :options="yearOptions" @KuramaSelect="anioSelected = $event"></px-select>
        </div>
          <!-- <pre>{{ evolucionGastoClayDes }}</pre> -->
           <!-- <div v-if="evolucionGastoClayDes.length > 0">
             <tabla-simple id="tablaEGCD" class="mt-2" :titulo="evolucionGastoClayDes[0].anio" :datos="evolucionGastoClayDes[0].contenido" />
           </div> -->
        <div v-for="(anio, j) in evolucionGastoClayDes" :key="j" class="mt-2">
          <h5>{{anio.anio}}</h5>
              <table-section :sections="evolucionGastoClayDes" :urlServe="urlServe"/>
        </div>
        <span v-html="fecha_actualizacion"></span>
      </div>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import InformeFinanzasPub from "@/services/rendicionDeCuentas/informeFinanzaPub/informeFinanzaPub.js";
const _serviciosInformeFinanzasPub = new InformeFinanzasPub();
import selectEjercicio from "../../../components/selectEjercicio.vue";
import DateFormat from "@/mixins/dateFormatMixin.js";
import tableSection from '../../../components/table.vue';
import tablaSimple from '@/components/tablaSimple.vue';
import botonAtras from '../../button-atras.vue';

import('@/assets/css/tablaTypeFiles.css');

export default {
  mixins: [DateFormat],
  components: { selectEjercicio, botonAtras, tableSection, tablaSimple},
  created(){
    window.scrollTo(0, 0);
    this.getGastosHistorico();
    this.getGastosClasifyDesag();
  },
  data(){
    return{
      gastosHistorico: {
        id: 1,
        text: "Historico",
        seccion: []
      },
      dataEvol: [],
      evolucionGastoClayDes: [],
      yearOptions: [],
      anioSelected: null,
      fecha_actualizacion:''
    }
  },
  methods:{
    async getGastosHistorico() {
      try {
          const response = await _serviciosInformeFinanzasPub.getEvolucionGastosHistorico(mapFun.evolucionGastosHistorico);
          this.gastosHistorico.seccion = response.data;
      } catch (error) {
          console.log('error', error.message);
      }
    },
    async getGastosClasifyDesag() {
      try {
          const response = await _serviciosInformeFinanzasPub.getEvolucionGastosClasiyDesag(mapFun.evolucionGastoClasifDesag);
          let data_reverse = response.data.reverse(); //para mostrar los años actuales primeros
          this.dataEvol = data_reverse;
      } catch (error) {
          console.log('error', error.message);
      }
    },
    async getAniosDocs() {
      try {
        this.yearOptions = this.dataEvol;
        this.yearOptions = this.yearOptions.map(function (mapeoSelect) {
          return {
            id: mapeoSelect.id,
            value: mapeoSelect.anio,
            text: mapeoSelect.anio.toString(),
          };
        });
      } catch (error) {
        console.log("error", error.message);
      }
    },
    async getGastosClasifyDesagByAnio() {
      try {
          this.evolucionGastoClayDes = this.dataEvol.filter(item => item.anio === this.anioSelected.value);
          let fecha_texto = this.evolucionGastoClayDes[0].fecha_actualizacion;
          this.fecha_actualizacion = this.DateFormatText(fecha_texto);
      } catch (error) {
          console.log('error', error.message);
      }
    },
  },
  watch:{
    anioSelected() {
      this.getGastosClasifyDesagByAnio();
    },
    dataEvol(){
      if(this.dataEvol){
        this.getAniosDocs();
      }
    }
  }
}
</script>
<style scoped>
ul li{
    list-style-type: none;
    list-style: none;
}
ul li a{
  color: #212529;
  border-bottom: 1px dotted #cfcfcf;
  margin-bottom: 0.3rem;
  font-size: 15px;
}
ul li:hover {
  transform: scale(1.01);
}
a:hover{color: #212529; text-decoration: none; transform: scale(1.01);}
.contenedor_evol_gasto{
  margin-top: 1rem;
  margin-bottom: 10rem;
}
</style>